<template>
    <data-exporter :title="title" :only-has-one-ori="onlyHasOneOri" :cancel-url="cancelUrl" :submit-url="submitUrl" :export-url="exportUrl" :filterable-fields="filterableFields" @date-range-update="handleDateRangeUpdate" @filter-info-update="handleFilterInfoUpdate">
    </data-exporter>
</template>
<script setup lang="ts">

import { computed, ref, watch } from 'vue';
import DataExporter from './Exporter/DataExporter.vue';
import {
    BFilter,
    BFilterOptions,
    BFilterOperation,
    BFilterableField,
    describeFilters,
listOperations,
textOperations,
} from "./BFilterEditor/BFilterEditor.types";
import { useCommunityPolicingStore } from '../stores/communityPolicingStore';

const props = defineProps<{
    title: string,
    onlyHasOneOri: boolean,
    cancelUrl: string,
    submitUrl: string
}>();

const communityPolicingStore = useCommunityPolicingStore();
const dateRangeFrom = ref([] as Date[]);
const filterInfo = ref({ filters: [] } as BFilterOptions);

const filterableFields = computed(() => {
    let data = [] as BFilterableField[];

    if (!props.onlyHasOneOri) {
        data.push({
            property: "agency",
            label: "Agency",
            operations: listOperations,
            editorComponent: "list-editor",
            editorOptions: communityPolicingStore.getOrisAsBFieldSelectionArray
        });
    }   

    data.push(
        {
            property: "incidentNumber",
            label: 'Stop Number',
            operations: textOperations,
            editorComponent: "text-editor",
        },
        {
            property: "uploaded-by",
            label: "Uploaded By",
            operations: textOperations,
            editorComponent: "text-editor",
        },
        {
            property: "file-name",
            label: "File Name",
            operations: textOperations,
            editorComponent: "text-editor"
        });
        
        return data;
});

var exportUrl = ref(generateExportUrl());

function generateExportUrl() {
    return communityPolicingStore.getExportUrl(dateRangeFrom.value, filterInfo.value, filterableFields.value)
};

function handleDateRangeUpdate(newDateRange: Date[]) {
    dateRangeFrom.value = newDateRange;
    exportUrl.value = generateExportUrl();
}

function handleFilterInfoUpdate(newFilterInfo: BFilterOptions) {
    filterInfo.value = newFilterInfo;
    exportUrl.value = generateExportUrl();
}

</script>